export class EmailConstants {
    // * here we can add the list of users for that we need to trigger a email to that whole group of users by comma separated and we can directly access this array while triggering that email
    // ! important: Change this email before making a deployment

    // * the logos which we are using in email template
    public static EMAIL_LOGOS = {
        HYDRATIGHT: 'https://idmsstorageaccount.blob.core.windows.net/dev-public/Management/Icon/Email/Hydratight.png',
        INTEGRITY_ASSURED: 'https://idmsstorageaccount.blob.core.windows.net/dev-public/Management/Icon/Email/Integrity_Assured.png',
    };

    public static WEBSITE_ACCESS_LINK = 'https://www.integrity-assured.com/';

    public static CONTACT_US_LINK = 'https://www.integrity-assured.com/contact-us';
}
